export const menuItems = [
    {
        label: "Dashboard",
        icon: "mdi mdi-apps",
        perm: "view_dashboard",
        link: "/"
    },
    {
        label: "Students",
        icon: "mdi mdi-account-multiple",
        perm: "view_students",
        subItems: [
            {
                label: "New Students",
                perm: "new_student",
                link: "/newstudent",
            },
            {
                label: "View Students",
                perm: "view_students",
                link: "/viewstudents",
            },
            {
                label: "Promote Students",
                perm: "view_students",
                link: "/migrate",
            },
            {
                label: "Parents",
                perm: "view_parents",
                link: "/viewparents",
            },
            {
                label: "Enrollments",
                perm: "view_enrollements",
                link: "/enrollments",
            },
        ]
    },
    {
        label: "Finance",
        icon: "mdi mdi-cash",
        perm: "view_finance",
        subItems: [
            {
                label: "Add Fees Payment",
                perm: "add_fees_payment",
                link: "/newfeespayments",
            },
            {
                label: "View Fees Payments",
                perm: "view_fees_payment",
                link: "/viewfeespayments",
            },
            {
                label: "Optional Fees Payments",
                perm: "optional_fees_payments",
                link: "/optionalfeespayments",
            },
            {
                label: "Student Bursaries",
                perm: "student_bursary",
                link: "/studentbursaries",
            },
            {
                label: "Fees Exemptions",
                perm: "student_bursary",
                link: "/feesexemptions",
            },
            {
                label: "Student Optional Fees ",
                perm: "student_bursary",
                link: "/setoptionalfees",
            },
            {
                label: "Previous Balances",
                perm: "fees_balances",
                link: "/previousbalances",
            },
        ]
    },
    {
        label: "Marks Entry",
        icon: "mdi mdi-clipboard-check",
        perm: "view_marks_entry",
        subItems: [
            {
                label: "AOI Marks",
                perm: "add_marks_entry",
                link: "/marksentry",
            },
            {
                label: "EOT Marks",
                perm: "add_marks_entry",
                link: "/eotmarksentry",
            },
            // {
            //     label: "View Exam Marks",
            //     perm: "view_marks_entry",
            //     link: "/viewmarks",
            // },
            {
                label: "Report Cards",
                perm: "report_cards",
                link: "/reportcards",
            },
            {
                label: "Exam Settings",
                perm: "exam_sets",
                link: "/examsettings",
            },
            {
                label: "Grading System",
                perm: "grading_system",
                link: "/grading",
            },
        ]
    },
    {
        label: "Expenses",
        icon: "mdi mdi-database",
        perm: "view_dashboard",
        subItems: [
            {
                label: "Record Expense",
                perm: "record_expenses",
                link: "/recordexpense",
            },
            {
                label: "View Expenses",
                perm: "view_expenses",
                link: "/viewexpenses",
            },
            {
                label: "Expense Items",
                perm: "expense_items",
                link: "/expenseitems",
            },
            {
                label: "Expense Categories",
                perm: "expense_categories",
                link: "/expensecategories",
            },
        ]
    },
    {
        label: "SickBay",
        icon: "mdi mdi-bed",
        perm: "view_sickbay",
        subItems: [
            {
                label: "Add a Visit",
                perm: "add_sickbay_visit",
                link: "/addvisits",
            },
            {
                label: "View Visits",
                perm: "view_sickbay_visit",
                link: "/viewvisits",
            },
        ]
    },
    {
        label: "Library",
        perm: "view_dashboard",
        icon: "mdi mdi-library",
        subItems: [
            {
                label: "Books Borrowed",
                perm: "books_borrowed",
                link: "/booksborrowed",
            },
            {
                label: "Book Categories",
                perm: "library_books",
                link: "/bookcategories",
            },
            {
                label: "Library Books",
                perm: "library_books",
                link: "/librarybooks",
            },
            {
                label: "Book Store",
                perm: "book_store",
                link: "/bookstore",
            },
            {
                label: "Library Settings",
                perm: "library_settings",
                link: "/comingsoon",
            },
        ]
    },
    {
        label: "School Events",
        icon: "mdi mdi-calendar",
        perm:'view_settings',
        link: "/events",
    },
    {
        label: "Human Resource",
        icon: "mdi mdi-account-settings",
        perm:'view_finance',
        subItems: [
            {
                label: "Staff Members",
                perm:'view_finance',
                link: "/staffmembers",
            },
            {
                label: "Positions",
                perm:'view_finance',
                link: "/positions",
            },
            {
                label: "Departments",
                perm:'view_finance',
                link: "/schooldepartments",
            },
            {
                label: "Salary Details",
                perm:'view_finance',
                link: "/salarydetails",
            },
            {
                label: "Allowances",
                perm:'view_finance',
                link: "/allowances",
            },
            {
                label: "Advances",
                perm:'view_finance',
                link: "/staffadvances",
            },
            {
                label: "Staff Leaves",
                perm:'view_finance',
                link: "/staffleaves",
            },
            {
                label: "Deductions",
                perm:'view_finance',
                link: "/deductions",
            },
        ]
    },  
    {
        label: "Inventory",
        icon: "mdi mdi-book",
        perm:'view_finance',
        subItems: [
            {
                label: "Units",
                perm:'view_finance',
                link: "/inventoryunits",
            },
            {
                label: "Items",
                perm:'view_finance',
                link: "/inventoryitems",
            },
            {
                label: "Store",
                subItems: [
                    {
                        label: "Add",
                        perm:'view_finance',
                        link: "/add-to-store",
                    }, 
                    {
                        label: "Loses",
                        perm:'view_finance',
                        link: "/store-loses",
                    },
                    {
                        label: "View",
                        perm:'view_finance',
                        link: "/view-store",
                    },
                ]
            },
            {
                label: "Requisition",
                subItems: [
                    {
                        label: "Add",
                        perm:'view_finance',
                        link: "/add-order",
                    }, 
                    
                    {
                        label: "View",
                        perm:'view_finance',
                        link: "/view-order",
                    },
                ]
            },
        ]
    },
    {
        label: "School Requirement",
        icon: "mdi mdi-clipboard-outline",
        perm:'view_finance',
        subItems: [
            {
                label: "Item",
                perm:'view_finance',
                link: "/school-requirement",
            },
            {
                label: "Allocation",
                perm:'view_finance',
                link: "/requirement-allocation",
            },
            {
                label: "Collection",
                perm:'view_finance',
                link: "/requirement-collection",
            },
            {
                label: "View  Collection",
                perm:'view_finance',
                link: "/view-requirement-collection",
            },           
        ]
    },
];